import styled, { css } from "styled-components";

export const SearchBarWrapper = styled.div`
  display: flex;
  width: 550px;
`;

const Note = css`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: auto 10px;
  flex-shrink: 0;
  flex-wrap: nowrap;
`;

export const NoValueNote = styled.div`
  ${Note}
  color: #b8860b;
  font-weight: 700;
`;

export const WarningNote = styled.div`
  ${Note}
  color: #F00;
  font-weight: 700;
`;
